import { useNavigate } from 'react-router-dom';
import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Signal = { prospectId: string; handle?: string; kind: string; summary: string; at: string };

// H.2.4: /outreach/prospects/:id retired — prospect links now scope the chat.
function ProspectBtn({ prospectId, label }: { prospectId: string; label: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="font-medium hover:underline text-left"
      onClick={() => {
        sessionStorage.setItem('outreach-scope', JSON.stringify({ prospectId }));
        navigate('/outreach');
      }}
    >
      {label}
    </button>
  );
}

export function FeedSignals(props: WidgetProps) {
  const signals = (decodeWidgetData(props.payload).signals ?? []) as Signal[];

  if (signals.length === 0) {
    return <p className="text-sm text-foreground-mute">No recent signals.</p>;
  }

  return (
    <ul className="space-y-2">
      {signals.map((s, i) => (
        <li key={`${s.prospectId}-${i}`} className="border-l-2 border-primary pl-3">
          <p className="text-[10px] text-foreground-mute">{s.at} · {s.kind}</p>
          <p className="text-sm">
            <ProspectBtn
              prospectId={s.prospectId}
              label={s.handle ? `@${s.handle}` : s.prospectId}
            />
            {' — '}
            {s.summary}
          </p>
        </li>
      ))}
    </ul>
  );
}
